import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { messages } from '../../../../messages';
import { R300 } from '@atlaskit/theme/colors';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { RetryAction } from '../../actions/flexible/RetryAction';
import Text from '../../../FlexibleCard/components/elements/text';
import UnresolvedView from './unresolved-view';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';

/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
const FlexibleErroredView = ({
  testId = 'smart-block-errored-view',
  ...props
}) => {
  const actions = useMemo(() => props.onAuthorize ? [RetryAction(props.onAuthorize)] : [], [props.onAuthorize]);
  return /*#__PURE__*/React.createElement(UnresolvedView, _extends({}, props, {
    actions: actions,
    testId: testId
  }), /*#__PURE__*/React.createElement(WarningIcon, {
    label: "errored-warning-icon",
    size: "small",
    primaryColor: `var(--ds-icon-warning, ${R300})`,
    testId: `${testId}-warning-icon`
  }), /*#__PURE__*/React.createElement(Text, {
    maxLines: 3,
    message: {
      descriptor: messages.could_not_load_link
    }
  }));
};
export default withFlexibleUIBlockCardStyle(FlexibleErroredView);